import Styled from "styled-components";
import { maxQuery } from "../../../helpers";

export default Styled.div`
padding-bottom: 3em;
header {
    margin-bottom: 1.5em;

    div.header-row {
        display: flex;
        align-items: center;
        grid-gap: 1em;
        button {
            background: transparent;
            padding: 0px;
            display: flex;
            align-items: center;
            border: none;
            .icon {
                color: ${({ theme }) => theme.primary};
                font-size: 1.6rem;
            }
        }
    }
    h1 {
        color: ${({ theme }) => theme.primary};
        font-size: 1.2rem;
        font-weight: 600;
    }
    nav {
        display: flex;
        margin-top: 0.5em;
        align-items: center;
        .icon {
            font-size: 1.2rem;
        }
        a {
            color: #A8A8A8;
            font-weight: 500;
            user-select: none;
            font-size: 0.8rem;
            &:hover, &:active, &:focus {
                text-decoration: underline;
                color: ${({ theme }) => theme.primary};
            }
            &.active {
                color: ${({ theme }) => theme.primary};
            }
        }
    }
}
div.profile-grid {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-gap: 2.5em;
    margin-bottom: 2em;
    ${maxQuery("md")} {
        grid-template-columns: 1fr;
    }

    .profile-card {
        background: #fff;
        padding: 2em;
        border-radius: 15px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        text-align: center;
        
        .trainer-photo {
            margin: 0 auto 1.5em;
            border: 4px solid #f8f9fa;
        }

        .trainer-name {
            font-size: 1.4rem;
            color: ${({ theme }) => theme.primary};
            margin-bottom: 0.2em;
        }

        .trainer-specialization {
            color: #666;
            font-size: 0.9rem;
            margin-bottom: 1.5em;
        }

        .trainer-meta {
            text-align: left;
            border-top: 1px solid #eee;
            padding-top: 1.5em;
            p {
                font-size: 0.9rem;
                margin-bottom: 0.8em;
                color: #444;
                strong {
                    color: #888;
                    font-weight: 500;
                    width: 90px;
                    display: inline-block;
                }
            }
        }
    }

    .profile-details {
       .detail-section {
          background: #fff;
          padding: 2em;
          border-radius: 15px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-bottom: 1.5em;

          h3 {
             color: ${({ theme }) => theme.primary};
             font-size: 1.1rem;
             margin-bottom: 1em;
             border-bottom: 2px solid #f0f0f0;
             padding-bottom: 0.5em;
          }

          p {
             color: #555;
             line-height: 1.6;
             font-size: 0.95rem;
          }
       }
    }
}
div.dontExist-container {
    display: flex;
    text-align: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 4em;
    .icon {
        font-size: 5rem;
        display: inline-block;
        margin: auto;
        margin-bottom: 0.1em;
    }
    h1 {
        font-size: 1rem;
        max-width: 20rem;
        margin: auto;
    }
}
  .filters-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .input-group {
      margin-bottom: 0;
      flex: 1;
      max-width: 250px;

      label {
        font-size: 13px;
        color: #666;
        margin-bottom: 8px;
        display: block;
        font-weight: 600;
      }

      input {
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        padding: 10px 12px;
        width: 100%;
        transition: all 0.3s ease;

        &:focus {
          border-color: #27ae60;
          box-shadow: 0 0 0 2px rgba(39, 174, 96, 0.1);
        }
      }
    }
  }
`;
